import React, { useMemo } from 'react';
import { TextField, Typography, InputAdornment } from '@mui/material';
import { StyledLimitedInput } from './index.style';

const LimitedInput = ({
  label,
  name,
  value = '',
  placeholder = '',
  onChange,
  error = false,
  helperText = '',
  maxLength = 25,
  showCounter = true,
  disabled = false,
  rows = 1,
  multiline = false,
  customStyle = {},
  styleTextField = {},
  description = '',
  ...props
}) => {
  const charCount = useMemo(() => (value || '').length, [value]);
  return (
    <StyledLimitedInput customStyle={customStyle}>
      <Typography className="input-label">{label}</Typography>
      {description && (
        <Typography className="input-description">{description}</Typography>
      )}
      <TextField
        name={name}
        type="text"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        size="small"
        className="input-field"
        fullWidth
        onChange={onChange}
        helperText={helperText}
        error={error}
        sx={{
          ...(multiline &&
            showCounter && {
              '& .MuiOutlinedInput-root': {
                flexDirection: 'column',
              },
            }),
          '& .MuiFormHelperText-root': {
            marginLeft: 0,
            marginTop: '8px',
          },
          ...(multiline && {
            '& .MuiInputAdornment-root': {
              height: '30px',
              width: '100%',
              backgroundColor: disabled ? 'transparent' : '#fff',
              display: 'flex',
              justifyContent: 'flex-end',
            },
          }),
          ...(styleTextField && styleTextField),
        }}
        InputProps={{
          endAdornment: showCounter ? (
            <InputAdornment position="end" sx={{ marginLeft: 'auto' }}>
              {charCount || 0}/{maxLength}
            </InputAdornment>
          ) : null,
        }}
        multiline={multiline}
        rows={rows}
        {...props}
      />
    </StyledLimitedInput>
  );
};

export default LimitedInput;
